import { useMutation } from '@tanstack/react-query';

import { sendPasswordlessEmail } from '@api';

export const useSendPasswordlessEmailMutation = () => {
  return useMutation({ mutationFn: sendPasswordlessEmail });
};
